import React from 'react';
import { Typography } from '../../components';

interface SimpleStatCardProps {
  label: string;
  value: string | number;
  className?: string;
}

export function SimpleStatCard({ label, value, className }: SimpleStatCardProps) {
  return (
    <div className={`flex flex-col py-4 p-4 gap-3 md:gap-4 ${className}`}>
      <Typography variant="body2" className="text-neutral-800 max-md:pb-0.5">
        {label}
      </Typography>
      <Typography variant="h5" className="!font-semibold !leading-auto max-md:text-2xl">
        {value}
      </Typography>
    </div>
  );
}
